export interface EnvironmentFilterType {
  options: EnvironmentOption[]
}

export interface EnvironmentOption {
  label: string
  value: server.dto.Environments
}

export const EnvironmentOptions: EnvironmentOption[] = [
  {
    label: RESX.UserType.Internal,
    value: "internal"
  },
  {
    label: RESX.UserType.External,
    value: "external"
  }
];

export const getOption = (value: server.dto.Environments): EnvironmentOption => {
  return (
    EnvironmentOptions.find((opt) => opt.value === value)
  );
};

export const initialEnvironmentFilter: EnvironmentFilterType = {
  options: []
};
